var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 96,
    fill: "none",
    viewBox: "0 0 92 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1D0A5",
    d: "M60.07 69.374a2.58 2.58 0 0 1-1.828.758 2.58 2.58 0 0 1-1.83-.758 2.588 2.588 0 0 1-3.66 3.66l-1.683-1.683a2.588 2.588 0 0 1-3.658 3.66h-.002c-5.855 4.387-18.511-10.454-21.927-14.677l-1.288-5.869 7.766-9.083c5.562-1.308 10.815-.461 10.815-.461l9.561 6.014 7.735 14.779a2.59 2.59 0 0 1 0 3.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1B986",
    d: "M47.41 75.01c-5.856 4.388-18.512-10.453-21.928-14.676l1.385-3.197c4.973 7.212 12.17 14.883 16.41 13.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2A770",
    d: "M65.362 59.318c-.373 1.137-.573 2.236-.105 3.194-2.104 3.066-4.447 4.337-4.513 4.373a2.6 2.6 0 0 0-.673-1.171L46.67 52.313c-1.657.552-3.421 2.033-4.705 3.292a3.26 3.26 0 0 1-2.284.933 3.26 3.26 0 0 1-2.07-.74l-.004-.004a3.26 3.26 0 0 1-.85-3.981c2.781-5.525 7.39-7.85 8.814-8.459.276-.118.575-.175.875-.164 1.38.05 2.747.327 4.045.737 4.39 1.38 7.864 3.838 8.709 4.545.753 1.976 6.358 3.385 7.186 5.33.694 1.627-.405 3.623-1.024 5.516"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5985C",
    d: "M65.257 62.512c-2.104 3.065-4.447 4.337-4.513 4.373a2.6 2.6 0 0 0-.673-1.171l-8.129-8.13c2.86 2.861 9.049 4.084 11.91 1.978.384-.281.9-.345 1.51-.244-.373 1.137-.572 2.236-.105 3.194m-27.65-6.717a3.26 3.26 0 0 1-.85-3.983c2.781-5.524 7.39-7.849 8.814-8.458.276-.118.575-.175.875-.164 1.38.05 2.747.327 4.045.737-6.094.003-14.673 10.11-12.884 11.868"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1B986",
    d: "M60.517 68.776a2.58 2.58 0 0 1-2.275 1.356 2.58 2.58 0 0 1-1.83-.759l-8.55-8.549a1.16 1.16 0 0 1 1.833-.255l7.76 7.76a2.58 2.58 0 0 0 1.83.759c.425 0 .85-.103 1.232-.312m-8.959 5.559a2.58 2.58 0 0 1-2.318 1.434 2.58 2.58 0 0 1-1.83-.759l-6.948-6.95a2.1 2.1 0 0 1 2.612.286l5.5 5.501a2.58 2.58 0 0 0 2.984.488m5.28-1.868a2.58 2.58 0 0 1-2.257 1.324 2.58 2.58 0 0 1-1.83-.758l-7.818-7.819a1.524 1.524 0 0 1 2.066.083l5.061 5.061 1.681 1.683a2.58 2.58 0 0 0 1.83.758c.438 0 .875-.11 1.267-.332"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4A54",
    d: "M71.448 65.384c3.176-1.376 3.5-7.682.724-14.085-2.775-6.402-7.6-10.475-10.775-9.099-3.176 1.377-3.5 7.683-.725 14.085s7.6 10.476 10.776 9.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C63D4F",
    d: "M74 60.233a20.2 20.2 0 0 1-8.128 3.522 165 165 0 0 1-2.02-4.193 21.5 21.5 0 0 0 8.483-3.643q.862 2.145 1.665 4.314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#698ED5",
    d: "M30.38 53.602c2.776-6.402 2.451-12.709-.724-14.085-3.176-1.377-8 2.697-10.776 9.099s-2.451 12.708.724 14.085c3.176 1.377 8-2.697 10.776-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4073C8",
    d: "M17 57.53a20.2 20.2 0 0 0 8.128 3.522q1.04-2.085 2.02-4.193a21.5 21.5 0 0 1-8.483-3.644Q17.803 55.36 17 57.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9F6D3",
    d: "M53.93 28.798a.86.86 0 0 1-.402-1.621l5.018-2.647a.86.86 0 0 1 .803 1.522l-5.019 2.646a.86.86 0 0 1-.4.1m5.016 10.678a.86.86 0 0 1-.4-.1l-5.018-2.646a.86.86 0 0 1 .802-1.522l5.019 2.647a.86.86 0 0 1-.403 1.621m1.417-6.662h-5.776a.86.86 0 1 1 0-1.72h5.776a.86.86 0 1 1 0 1.72M37.07 28.798a.86.86 0 0 1-.4-.1l-5.019-2.646a.86.86 0 1 1 .803-1.522l5.018 2.647a.86.86 0 0 1-.402 1.621m-5.017 10.678a.86.86 0 0 1-.402-1.621l5.018-2.647a.86.86 0 0 1 .803 1.522l-5.018 2.647a.86.86 0 0 1-.401.1m4.36-6.663h-5.776a.86.86 0 1 1 0-1.72h5.776a.86.86 0 1 1 0 1.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78D090",
    d: "M46.943 28.355a34 34 0 0 1-.654-.238V24.51c.465.128.763.351.851.425a.86.86 0 0 0 1.1-1.323 4.2 4.2 0 0 0-1.95-.858v-.707a.86.86 0 0 0-1.72 0v.77q-.154.035-.31.082c-1.157.348-2.021 1.337-2.256 2.581-.214 1.137.152 2.234.954 2.863.411.323.92.618 1.611.928v4.627c-.585-.052-.974-.207-1.622-.632a.86.86 0 0 0-.942 1.44c1 .655 1.691.86 2.564.916v.792a.86.86 0 0 0 1.72 0v-.863c1.774-.374 2.81-1.847 3.042-3.225.302-1.793-.636-3.352-2.388-3.97M44.02 26.99c-.291-.228-.419-.696-.325-1.191.08-.43.353-.94.874-1.181v2.732a4.5 4.5 0 0 1-.55-.36m3.615 5.051c-.114.677-.571 1.395-1.346 1.712v-3.805l.08.03c1.412.498 1.326 1.705 1.266 2.063"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 20h57v57H17z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 92,
    height: 96,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.274167 0 0 0 0 0.30731 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2001_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2001_8",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestIcon);
export default __webpack_public_path__ + "static/media/invest_icon.3b91a1b4a0e7e4a0b2f05e13f2fe1bd9.svg";
export { ForwardRef as ReactComponent };